import * as React from 'react';
import type { SVGProps } from 'react';

const SvgOk = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="m1147.3 701.72-4.473-153.88-33.195-165.76-1.898-72.555-.625.016-111.08 4.656-227.97 6.074-228.18 1.617-126.72-1.008-126.62-2.472-119.27-3.531-121.77-5.618-3.504 78.293 127.48 5.305 127.64 3.84 127.6 2.512-2.117 154.84-2.16 151 31.043 17.398 21.23 13.16 34.605-10.305 19.316 32.938 44.105 11.43 39.207 8.511 61.344-4 17.586 38.008 39.516-16.238 37.305 24.11 36.25 9.644 20.207-23.254 20.57 26 43.965-9.61 19.59 7.286 21.945-7.207 22.238-13.56 27.496-1.105 46.48.07 29.609-11.828 37.672 15.316 58.277 28.496z" />
  </svg>
);
export default SvgOk;
